module.exports = __webpack_public_path__ + "img/gear.3b6a35e9.svg";